import React, { useState, useEffect } from 'react';
import Header from "../../../../src/components/Header/Header";
import { DataGridPro } from "@mui/x-data-grid-pro";
import Button from "@mui/material/Button";
import { Grid } from "@mui/material";
import Controls from '../../Loyalty/dealerManagement/Controls';
import Axios from "axios";
import { API_URL_UMS } from '../../../Constant';
import moment from 'moment';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { onExportExcel } from '../../../_helpers/exportExcel';

const INITIAL_FILTER_STATE = {
    "role": "",
    "fromDate": null,
    "toDate": null
}

function onYearFarword(fromDate) {
    const addOneYear = moment(fromDate).add(1, 'years').format('DD MMM YYYY')
    const minusOneDay = moment(addOneYear).subtract(1, 'days').format('DD MMM YYYY')
    return minusOneDay;
}

function onYearBack(fromDate) {
    let minusOneYear = moment(fromDate).subtract(1, 'years').format('DD MMM YYYY')
    let addOneDay = moment(minusOneYear).add(1, 'days').format('DD MMM YYYY')
    let tdate = moment(moment(fromDate).format('DD MMM YYYY'));
    let minDate = moment(moment("2021-01-01").format('DD MMM YYYY'))
    const dif = tdate.diff(minDate, 'days');
    const l = moment(fromDate).subtract(dif, 'days').format('DD MMM YYYY');
    return dif > 365 ? addOneDay : l;
}

const MINIMUM_DATE = new Date("2021-01-01");

const RolePermissionChange = () => {
    const [filterState, setFilterState] = useState(INITIAL_FILTER_STATE);
    const [dateError, setDateError] = useState("");
    const [showLoading, setShowLoading] = useState(false)
    const [permissionRow, setPermissionRow] = useState([])
    const [roleList, setRoleList] = useState([])
    const [open, setOpen] = React.useState(false);
    const [openOld, setOpenOld] = React.useState(false);
    const [scroll, setScroll] = React.useState('paper');
    const [popupData, setPopupData] = useState(null)

    function handleFilterChange(e) {
        setPermissionRow([])
        setDateError("")
        setFilterState({ ...filterState, [e.target.name]: e.target.value });
    }

    const onFilterSearch = (isDownload) => {
        if (filterState.role === "" || filterState.role === "Select") {
            setDateError("role")
            return 0;
        }
        setDateError("")
        let fDate = filterState.fromDate ? moment(filterState.fromDate).format("DD-MM-YYYY") : ""
        let tDate = filterState.toDate ? moment(filterState.toDate).format("DD-MM-YYYY") : ""
        let queryString = `role=${filterState.role}&fromDate=${fDate}&toDate=${tDate}`;

        setShowLoading(true)
        const requestOptions = {
            headers: {
                "Content-Type": "application/json",
                "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
            },
        };
        Axios.get(`${API_URL_UMS}audit/rolePermissionsAuditReport?${queryString}`,
            requestOptions
        )
            .then((response) => {
                console.log("responsewwwww :", response.data)

                if (isDownload) {
                    let url = response.data[0].role;
                    window.open(url)
                } else {
                    setPermissionRow(response.data)
                    setShowLoading(false)
                }
            })
            .catch((error) => { });
    }

    const handleClickOpen = (scrollType, row) => () => {
        setOpen(true);
        setScroll(scrollType);
        setPopupData(row)
        console.log("RowData : ", row)
    };

    const handleClickOpenOld = (scrollType, row) => () => {
        setOpenOld(true);
        setScroll(scrollType);
        setPopupData(row)
        console.log("RowData : ", row)
    };

    const handleClose = () => {
        setOpen(false);
        setOpenOld(false)
    };

    const descriptionElementRef = React.useRef(null);
    React.useEffect(() => {
        if (open || openOld) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open, openOld]);

    const columns = [
        {
            field: "role",
            headerName: "Role",
            headerAlign: "center",
            align: 'center',
            width: 250
        },
        {
            field: "currentPermissions",
            headerName: "Old Permissions",
            headerAlign: "center",
            align: 'left',
            width: 300,
            renderCell: ({ row }) => {
                return <span onMouseOver={handleClickOpenOld('paper', row)}>{(row.currentPermissions.toString()).substring(0, 35)}</span>
            },
        },
        {
            field: "newPermissions",
            headerName: "New Permissions",
            headerAlign: "center",
            align: 'center',
            width: 300,
            flex: 1,
            renderCell: ({ row }) => {
                return <span onMouseOver={handleClickOpen('paper', row)}>{(row.newPermissions.toString()).substring(0, 35)}</span>
            },
        },
        {
            field: "createdDate",
            headerName: "Changed At",
            headerAlign: "center",
            align: 'center',
            width: 120,
            sortable: true,
            flex: 1,
            renderCell: ({ row }) => {
                return <div>{moment(row.createdDate).format("DD-MM-YYYY HH:mm")}</div>;
            },
        }
    ];

    useEffect(() => {

        const requestOptions = {
            headers: {
                "Content-Type": "application/json",
                "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
            },
        };
        Axios.get(
            `${API_URL_UMS}audit/role`,
            requestOptions
        )
            .then((response) => {
                let roleResponse = response.data && response.data.length > 0 && response.data.map(item => item.role)
                setRoleList(roleResponse)
            })
            .catch((error) => {
            });
    }, [])

    var fdate = moment(onYearFarword(filterState.fromDate));
    var now = moment();


    function modifyColumns(columns) {
        return columns.map((item) => {
            return ({
                label: item.headerName,
                value: item.field,
                ...item
            })
        })
    }

    function modifyRows(rowdata) {
        const data = rowdata.map((item) => {
            return ({
                ...item,
                createdDate: moment(item.createdDate).format("DD-MM-YYYY HH:mm"),
                currentPermissions: item.currentPermissions.toString(),
                newPermissions: item.newPermissions.toString(),
            })
        })
        return data
    }
    return (
        <div className="content-wrapper">
            <Header title="Role Permissions Audit Report" />
            <div className="row ipad_css ">
                <div className="mainScroll">
                    <div className="col-12 mt-2">
                        <div className="pCalFormControll">
                            <Grid container>
                                <Grid item md={3} xs={12}>
                                    <Controls.Select
                                        name="role"
                                        label="Role"
                                        options={roleList}
                                        onChange={handleFilterChange}
                                        showSelect={true}
                                        selectValue="Select"
                                        {...(dateError === "role" && { error: "Required" })}
                                    />
                                </Grid>
                                <Grid item md={3} xs={12}>
                                    <Controls.DatePicker
                                        name="fromDate"
                                        label="From Date"
                                        onChange={handleFilterChange}
                                        value={filterState.fromDate}
                                        maxDate={
                                            typeof filterState.toDate === "object" && filterState.toDate != null && filterState.toDate != "Invalid Date"
                                                ? filterState.toDate
                                                : new Date()
                                        }
                                        minDate={
                                            typeof filterState.toDate === "object" && filterState.toDate != null && filterState.toDate != "Invalid Date"
                                                ? onYearBack(filterState.toDate)
                                                : MINIMUM_DATE
                                        }
                                    />
                                </Grid>

                                <Grid item md={3} xs={12}>
                                    <Controls.DatePicker
                                        name="toDate"
                                        label="To Date"
                                        onChange={handleFilterChange}
                                        value={filterState.toDate}
                                        minDate={
                                            typeof filterState.fromDate === "object" && filterState.fromDate != null && filterState.fromDate != "Invalid Date"
                                                ? filterState.fromDate
                                                : MINIMUM_DATE
                                        }
                                        maxDate={
                                            fdate >= now ||
                                                onYearFarword(filterState.fromDate) === "Invalid date"
                                                ? new Date()
                                                : onYearFarword(filterState.fromDate)
                                        }
                                    />
                                </Grid>

                                <Grid item md xs display="flex" justifyContent="flex-end">
                                    <Button
                                        variant="contained"
                                        className="btncolor"
                                        size="small"
                                        sx={{ m: 1 }}
                                        onClick={() => onFilterSearch(false)}
                                    >
                                        Search
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        color="secondary"
                                        className="outlineButton"
                                        size="small"
                                        sx={{ m: 1 }}
                                        onClick={() => onExportExcel(modifyColumns(columns), modifyRows(permissionRow), "Role_Permission_Report", "Role_Permission_Report")}
                                    >
                                        Download
                                    </Button>
                                </Grid>
                            </Grid>
                        </div>
                        <div className="DataGridContainer">
                            <DataGridPro
                                style={{ fontSize: "14px" }}
                                rows={permissionRow}
                                columns={columns}
                                localeText={{
                                    noRowsLabel: "No Data",
                                }}
                                disableColumnMenu={true}
                                disableColumnReorder={true}
                                disableColumnSelector={true}
                                disableColumnResize={true}
                                loading={showLoading}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <Dialog
                open={open}
                onClose={handleClose}
                scroll={scroll}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <DialogTitle id="scroll-dialog-title">New Permissions</DialogTitle>
                <DialogContent dividers={scroll === 'paper'}>
                    <DialogContentText
                        id="scroll-dialog-description"
                        ref={descriptionElementRef}
                        tabIndex={-1}
                    >
                        {popupData && popupData.newPermissions.length > 0 && popupData && popupData.newPermissions.map((item) => <p>{item}</p>)}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Close</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={openOld}
                onClose={handleClose}
                scroll={scroll}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <DialogTitle id="scroll-dialog-title">Old Permissions</DialogTitle>
                <DialogContent dividers={scroll === 'paper'}>
                    <DialogContentText
                        id="scroll-dialog-description"
                        ref={descriptionElementRef}
                        tabIndex={-1}
                    >
                        {popupData && popupData.newPermissions.length > 0 && popupData && popupData.currentPermissions.map((item) => <p>{item}</p>)}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Close</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default RolePermissionChange